var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.disabled
    ? _c(
        "div",
        { staticClass: "tooltip" },
        [
          _c("NsIcon", {
            staticClass: "top-arrow",
            attrs: {
              "icon-name": "icon-top-arrow-with-shadow-24",
              size: "custom",
            },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "tooltip-box" }, [
            _c("p", { staticClass: "tooltip-paragraph" }, [
              _vm._v(_vm._s(_vm.message)),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "tooltip-icon-close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.$emit("close", $event)
                  },
                },
              },
              [
                _c("NsIcon", {
                  staticClass: "icon-close",
                  attrs: { "icon-name": "icon-close", size: "custom" },
                }),
              ],
              1
            ),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }